export const GUEST_CART_STORAGE_KEY = "gem_guest_cart_v1";
export const WISHLIST_STORAGE_KEY = "gem_wishlist_v1";
export const RECENTLY_VIEWED_STORAGE_KEY = "gem_recently_viewed_v1";
